import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { useDownloadReport, useListReport, useListTypeReport } from "hooks";
import useUserList from "pages/RouteManagement/useUserList";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setListReportColumn } from "store/actions";
import DetailReport from "./DetailReport";
import {
  getInitReportParams,
  reportAuthStatus,
  reportAuthStatusMode,
  reportModeList,
} from "./utils";

const ListReport = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["reportManagement"]);
  const { optionUserScan, myHubs, isHubAdmin, isLogAdmin } = useUserList();
  // const isDocumentStatistics = CheckActionAccess(
  //   actionAccess.DOCUMENT_STATISTICS_REPORT_MANAGEMENT
  // );

  // const isExportReport = CheckActionAccess(
  //   actionAccess.EXPORT_REPORT_MANAGEMENT
  // );

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  // Detail Report Modal
  const [dataDetail, setDataDetail] = useState({});
  const [isOpenDetailModal, setIsOpenDetailModal] = useState(false);

  // List Type Report
  const { data: typeReportList, refetch: fetchListTypeReport } =
    useListTypeReport({});

  // List Report
  const [reportParams, setReportParams] = useState(getInitReportParams);
  const {
    isLoading: isLoadingList,
    data: reportList,
    refetch: listReport,
  } = useListReport({ params: reportParams });

  // Download Report
  const onSuccessDownloadReport = data => {
    const linkDownload = document.createElement("a");
    linkDownload.href = data.fileUrl;
    linkDownload.setAttribute("download", data.fileName);
    document.body.appendChild(linkDownload);
    linkDownload.click();
  };
  const { mutate: downloadReport } = useDownloadReport(onSuccessDownloadReport);

  const reportManagement = useSelector(state => state.reportManagement);
  const {
    list: { columnsVisible: reportColumnsVisible },
  } = reportManagement;

  useEffect(() => {
    if (reportParams && reportParams.run) {
      listReport();
    }
  }, [reportParams]);

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    if (myHubs) {
      if (isHubAdmin) {
        setReportParams(prev => ({
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            "filter[creator_hub_id]": myHubs.hub.id,
          },
          run: true,
        }));
      } else {
        const listChildHub =
          myHubs.childs_hub && myHubs.childs_hub.length > 0
            ? myHubs.childs_hub.flatMap(item => item.id)
            : [];
        const listHubCenter = [myHubs.hub.id, ...listChildHub];
        setReportParams(prev => ({
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            creator_hub_ids: listHubCenter?.join(","),
          },
          run: true,
        }));
      }
    }

    fetchListTypeReport();

    initColumn();
  }, [t, myHubs, isHubAdmin]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (reportList) {
      initColumn();
    }
  }, [reportList, typeReportList]);

  const initColumn = () => {
    if (reportColumnsVisible && Object.keys(reportColumnsVisible).length > 0) {
      initColumns.forEach(item => {
        if (reportColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !reportColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListReportColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "auth_status":
        if (prefix === "report") {
          options = reportAuthStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    // Set option to select with Array values defined
    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    // Use For Column Formatter
    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "auth_status":
        if (prefix === "report") {
          options = reportAuthStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setReportParams(prev => {
      const columnFilterClone = {
        ...prev.columnFilter,
        ...columnFilter,
      };
      if (columnFilterClone && Object.keys(columnFilterClone).length > 0) {
        // Convert filter Select "Equal" To "Like"
        if (
          Object.keys(columnFilterClone).some(x => x.includes("object_type"))
        ) {
          const keyFind = Object.keys(columnFilterClone).find(x =>
            x.includes("object_type")
          );
          columnFilterClone[`${keyFind}[like]`] = columnFilterClone[keyFind];
          delete columnFilterClone[keyFind];
        }
      }

      return {
        ...prev,
        sort: sortField ? sortOrder + sortField : reportParams.sort,
        columnFilter: columnFilterClone || {},
        page: page || 1,
        sizePerPage: sizePerPage || 10,
      };
    });
  };

  const onSearchAllHandle = value => {
    setReportParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const toggleOpenDetailModal = (modeSet = "") => {
    setIsOpenDetailModal(!isOpenDetailModal);
    switch (modeSet) {
      // case shippingUnitModeList.EDIT_SHIPPING_UNIT_DETAIL:
      //   listShippingUnit();
      //   break;
      default:
        break;
    }
  };

  const rowEventsHandler = {};

  const listRowAction = [
    {
      icon: <i className="fas fa-eye fa-lg text-primary" />,
      text: t("table.actions.view.report"),
      onClick: (row, index) => {
        setDataDetail({ reportId: row.id });
        setMode(reportModeList.VIEW_REPORT_DETAIL);
        toggleOpenDetailModal();
      },
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "object_type",
      text: t("table.object_type.report.name"),
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={reportParams.columnFilter}
          dataSelect={
            typeReportList?.items?.length > 0
              ? typeReportList.items.map(item => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                })
              : []
          }
          placeholder={t("placeholder.select")}
        />
      ),
      formatter: (cell, row) => {
        if (typeReportList?.items?.length > 0) {
          const objectType = typeReportList.items.find(
            item => String(cell) === String(item.id)
          );
          if (objectType) {
            return <strong>{objectType.name}</strong>;
          }
        }
        return cell;
      },
    },
    {
      isDummyField: true,
      dataField: "df_download_report",
      text: t("table.df_download_report"),
      align: "center",
      // hidden: !isExportReport,
      formatter: (cell, row) => {
        if (row.id && row.auth_status === reportAuthStatusMode.COMPLETED) {
          return (
            <React.Fragment>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  downloadReport({
                    fileId: row.id,
                    fileName: `report_${
                      row.maker_date ? row.maker_date : new Date().getTime()
                    }.xlsx`,
                  });
                }}
              >
                <i className="fas fa-download fa-lg text-success" />
              </div>
            </React.Fragment>
          );
        }
      },
    },
    {
      dataField: "auth_status",
      text: t("table.auth_status.report.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.auth_status.report.name"),
        }),
        options: selectOptionsTable(undefined, "auth_status", "report"),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell && reportAuthStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "auth_status", "report");
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={reportParams.columnFilter}
        />
      ),
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      hidden: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={reportParams.columnFilter}
        />
      ),
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={reportParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${reportList?.totalCount || 0})`}
            breadcrumbItems={[{ name: t("title.list") }]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail Report Modal */}
              <DetailReport
                dataDetail={dataDetail}
                isOpenModal={isOpenDetailModal}
                toggleModal={toggleOpenDetailModal}
                mode={mode}
                typeReportList={typeReportList}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  {columnsTable.length > 0 && (
                    <RemoteDataTable
                      // selectRow={selectRowCheckbox}
                      keyField="id"
                      data={reportList?.items || []}
                      columns={columnsTable}
                      page={reportParams.page}
                      sizePerPage={reportParams.sizePerPage}
                      totalSize={reportList?.totalCount || 0}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandler}
                      rowEvents={rowEventsHandler}
                      listMultipleRowAction={listMultipleRowAction}
                      listRowAction={listRowAction}
                      loading={isLoadingList}
                    >
                      <Link
                        to="/report-management/statistic"
                        className="btn btn-primary btn-label"
                      >
                        <i className="fas fa-plus label-icon" />
                        {t("title.statistic")}
                      </Link>
                    </RemoteDataTable>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListReport;
